import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import PublicBandPreviewPanel from "./PublicBandPreviewPanel";
import PopupOverlay from "../Background/PopupOverlay";

export default function BandInfoModal({ isOpen, onClose, band }) {
    if (!isOpen) {
        return null;
    }
    return ReactDOM.createPortal(
        <PopupOverlay onClose={onClose} closeOnOverlayClick closeOnEsc>
            <div className="band-info-modal__container" role="dialog" aria-modal="true" aria-labelledby="bandInfoTitle">
                <PublicBandPreviewPanel
                    band={band || null}
                    isLoading={false}
                    onBack={onClose}
                />
            </div>
        </PopupOverlay>,
        document.getElementById("portal")
    );
}

BandInfoModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    band: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        description: PropTypes.string,
        visibility: PropTypes.string,
        timezone: PropTypes.string,
        activeMemberCount: PropTypes.number,
        createdAt: PropTypes.string,
        updatedAt: PropTypes.string,
    }),
};

BandInfoModal.defaultProps = {
    isOpen: false,
    onClose: undefined,
    band: null,
};
